export const NEW_DOC_PATH = "new";

export const VISI_ROUTE = "visi";
export const READABILITY_ROUTE = "readability";
